import React from 'react';

import ActionCell from 'app/audit-logs/audit-logs-table/action-cell';
import DescriptionCell from 'app/audit-logs/audit-logs-table/description-cell';
import TimestampCell from 'app/audit-logs/audit-logs-table/timestamp-cell';

import AuditLogRowToggleButton from './AuditLogRowToggleButton';
import AuditLogUserCell from './AuditLogUserCell';

export default function buildAuditLogTableColumns({ expandedRowId, onToggle, showDebugData }) {
  const toggleColumn = {
    name: '',
    width: '56px',
    cell: row => <AuditLogRowToggleButton row={row} expanded={row.id === expandedRowId} onToggle={onToggle} />,
  };

  return [
    ...(showDebugData ? [toggleColumn] : []),
    { name: 'Action', cell: row => <ActionCell action={row.action} /> },
    {
      name: 'User',
      cell: row => <AuditLogUserCell userName={row.userName} userEmail={row.userEmail} userId={row.userId} />,
    },
    { name: 'Description', cell: row => <DescriptionCell description={row.description} /> },
    { name: 'Date', id: 'timestamp', sortable: true, cell: row => <TimestampCell timestamp={row.timestamp} /> },
  ];
}
